import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ClientLogoStripComponent } from '../../../shared/components/client-logo-strip/client-logo-strip.component';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-communities-page',
  standalone: true,
  imports: [CommonModule, RouterModule, MatCardModule, MatIconModule, MatButtonModule, ClientLogoStripComponent],
  templateUrl: './communities-page.component.html',
  styleUrl: './communities-page.component.scss'
})
export class CommunitiesPageComponent {
  constructor(@Inject(PLATFORM_ID) private readonly platformId: Object) {}

  scrollToExplore(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('explore-communities')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  manageItems = [
    { icon: 'badge', label: 'Memberships and renewals' },
    { icon: 'event', label: 'Events and registrations' },
    { icon: 'people', label: 'Member directories' },
    { icon: 'campaign', label: 'Communication and announcements' },
    { icon: 'account_tree', label: 'Chapters and leadership' },
    { icon: 'payments', label: 'Payments and dues' }
  ];

  communities = [
    {
      title: 'Medical & Surgical Societies',
      description: 'Membership organizations for medical specialties managing renewals, annual meetings, CME events, and member directories.',
      icon: 'medical_services',
      route: '/communities/medical-societies',
      examplesLabel: 'Used by societies such as',
      examples: ['Northwest Society of Colon and Rectal Surgeons', 'Southern California Society of Colon and Rectal Surgeons', 'SAAV Society', 'Surgical Outcomes Club'],
      ctaText: 'Explore medical society communities',
      bannerStyle: 'medical',
      imageUrl: '/img/medical-hero.webp'
    },
    {
      title: 'Physician Entrepreneurs',
      description: 'Communities of physicians building businesses, investing, and supporting each other through networking groups, mastermind communities, and entrepreneur networks.',
      icon: 'groups',
      route: '/communities/physician-entrepreneurs',
      examplesLabel: 'Communities like',
      examples: ['Women Physician Entrepreneurs of Houston', 'Physician startup networks', 'Physician real estate investor groups'],
      ctaText: 'Explore physician entrepreneur communities',
      bannerStyle: 'entrepreneur',
      imageUrl: '/img/physicians-card.webp'
    }
  ];

  /** Set to a path e.g. /img/communities/product-overview.webp to show a product screenshot in the manage section */
  productScreenshotUrl: string | undefined = undefined;

  /** Set to a path to show a subtle visual above the bottom CTA buttons */
  ctaVisualUrl: string | undefined = undefined;
}
